"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const CreateNewButton_1 = __importDefault(require("../Button/CreateNewButton"));
const EmptyStateBasePage_1 = require("./EmptyStateBasePage");
function EmptyFolderState({ showCreateButton = false, t }) {
    return (react_1.default.createElement(EmptyStateBasePage_1.EmptyStateBasePage, { body: t('emptyStateDefaultBody'), imgSrc: "/images/empty-state.svg" }, showCreateButton && react_1.default.createElement(CreateNewButton_1.default, { buttonSize: "med" })));
}
exports.default = (0, react_i18next_1.withTranslation)('EmptyState')(EmptyFolderState);
